import { normalizeRid } from '../../../shared/model/scopeKeys'

export { normalizeRid, ownedBy } from '../../../shared/model/scopeKeys'

/**
 * Ключи намерения инвентаризации — с rid (D-064): склад с тем же GUID в двух
 * базах — две разные сессии, два черновика и два скана.
 */
export const sessionKey = (resourceId: string, warehouseRefKey: string): string =>
  `${normalizeRid(resourceId)}|${warehouseRefKey.trim().toLowerCase()}`

export const createKey = (resourceId: string, warehouseRefKey: string, rowId: string): string =>
  `${sessionKey(resourceId, warehouseRefKey)}|${rowId.toLowerCase()}`

/** Какие команды инвентаризации уходят в 1С с ключом идемпотентности. */
export type InventoryCommandAction = 'save' | 'create' | 'clear'

/** Ключ привязан к операции: одинаковые ключи в двух базах — две операции и на сервере. */
export const inventoryIdempotencyKey = (action: InventoryCommandAction, operationId: string): string =>
  `onec-ui:inventory-${action}:${operationId}`
